
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block border border-gray-300 px-4 py-2 rounded-full text-xs text-gray-600 mb-8">
              ABOUT US
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold mb-2">
              <span className="text-gray-900">專業通訊服務</span>
            </h2>
            <h3 className="text-4xl lg:text-5xl font-light text-teal-600 mb-12">
              值得信賴的選擇 🏆
            </h3>

            <p className="text-base text-gray-700 leading-relaxed mb-8">
              我們擁有 10 年以上通訊產業經驗，提供門號申辦、手機銷售、配件選購等一站式服務。專業團隊隨時為您解答疑問，協助您找到最適合的通訊方案。無論是個人用戶或企業客戶,我們都能提供最專業的建議與最優質的服務。
            </p>

            <a href="#consultation" className="inline-block text-gray-900 font-medium border-b-2 border-gray-900 pb-1 hover:text-teal-600 hover:border-teal-600 transition-colors cursor-pointer">
              了解更多關於我們
            </a>
          </div>

          <div className="relative">
            <div className="absolute -top-8 -right-8 flex space-x-16">
              <div className="text-center">
                <div className="text-5xl font-bold text-gray-900 mb-2">10+</div>
                <div className="text-sm text-gray-600">服務年資</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-gray-900 mb-2">5000+</div>
                <div className="text-sm text-gray-600">滿意客戶</div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-24">
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <div className="w-full h-64">
                  <img
                    src="https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/bda84a16ddc2244ff87a73ae052bbcb3.jpeg"
                    alt="門市外觀"
                    className="w-full h-full object-cover object-center"
                    style={{ objectPosition: 'center 35%' }}
                  />
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg mt-12">
                <div className="w-full h-80">
                  <img
                    src="https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/85ba53e8b2cd4652b10b35c63afca277.jpeg"
                    alt="門市內部"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
